import React from 'react'
import { makeStyles } from '@material-ui/core'
import SkiptownConfettiImage from '../../../assets/skiptown-confetti.png'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row'
	},
	textContainer: { display: 'flex', flexDirection: 'column', width: '50%', gap: '1.25rem', padding: '5%' },
	sectionName: {
		fontFamily: 'Nunito',
		fontSize: '1rem',
		fontWeight: FONT_WEIGHTS.SemiBold,
		textTransform: 'uppercase'
	},
	sectionTitle: { fontFamily: 'Nunito', fontSize: '2.5rem', fontWeight: FONT_WEIGHTS.SemiBold },
	sectionDescription: { fontFamily: 'Nunito', fontSize: '1.25rem', fontWeight: FONT_WEIGHTS.Normal },
	imageContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '50%',
		padding: '5%'
	},
	image: { width: '100%' }
}))

const IntroView = ({
	sectionName = '',
	sectionTitle = '',
	sectionDescription = '',
	imgSrc = SkiptownConfettiImage
}) => {
	const classes = useStyles()
	return (
		<div className={classes.root}>
			<div className={classes.textContainer}>
				<div style={{ flex: 1 }} />
				<div className={classes.sectionName}>{sectionName}</div>
				<div className={classes.sectionTitle}>{sectionTitle}</div>
				<div className={classes.sectionDescription}>{sectionDescription}</div>
				<div style={{ flex: 1 }} />
			</div>
			<div className={classes.imageContainer}>
				<img className={classes.image} src={imgSrc} />
			</div>
		</div>
	)
}

export default IntroView
